<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_pay.webp`)" alt="Payment methods banner for PC">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          入金および出金方法
        </h1>
        <h2 class="subheading fs_6">
          銀行振込、仮想通貨、などの方法で入金および出金が可能です：
        </h2>

        <img class="table-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/table.png`)" alt="Table of payment methods">
        <h2 class="subheading fs_6" :style="{ color: '#ca3044' }">
          ※銀行振込の最低入出金額は、決済プロバイダのメンテナンスにより変動する場合がございます。
        </h2>
        <h2 class="main-title">
          入出金手順一覧
        </h2>
        <h2 class="subheading fs_6">
          <ul class="method-items">
            <li><a class="links anchorTo" @click="scrollTo('getWay_1')">銀行振込で入金する方法 </a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_3')">USDT TRC20で入金する方法</a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_4')">USDT ERC20で入金する方法</a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_5')">銀行キャッシュカードで出金する方法</a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_7')">USDT TRC20の出金方法</a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_8')">USDT ERC20の出金方法</a></li>
          </ul>
        </h2>
        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_1" class="main-title">
          銀行振込で入金する方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': toggleStates.getWay1}" @click="toggleState('getWay1')">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !toggleStates.getWay1}" @click="toggleState('getWay1')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 tab-contents -->
            <div class="tab-contents" :class="{'is-contents-active': toggleStates.getWay1}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_01.png`)" alt="User clicking 'Deposit' on the home screen for PC">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <h3 class="subheading fs_6">
                「銀行振込」を選択
              </h3>
              <p class="text_center h2-type">
                1. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                2. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                3. 「入金」をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_02.png`)" alt="User selecting 'Bank Transfer' and entering amount for PC">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !toggleStates.getWay1}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をクリック
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_01.png`)" alt="User clicking 'Deposit' on the home screen for mobile">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <h3 class="subheading fs_6">
                「銀行振込」を選択
              </h3>
              <p class="text_center h2-type">
                1. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                2. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                3. 「入金」をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_02.png`)" alt="User selecting 'Bank Transfer' and entering amount for mobile">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_3" class="main-title">
          USDT TRC20で入金する方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-3 " :class="{'is-btn-active': toggleStates.getWay3}" @click="toggleState('getWay3')">
              PC版
            </li>
            <li class="tab-list-item-group-3 " :class="{'is-btn-active': !toggleStates.getWay3}" @click="toggleState('getWay3')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-3" :class="{'is-contents-active': toggleStates.getWay3}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_01.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                1.「USDT TRC20」を選択<br>
                ※「USDT TRC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                2. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                3. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                4. 「入金」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_04.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-3 " :class="{'is-contents-active': !toggleStates.getWay3}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_01.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                1.「USDT TRC20」を選択<br>
                ※「USDT TRC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                2. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                3. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                4. 「入金」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_04.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_4" class="main-title">
          USDT ERC20で入金する方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-4" :class="{'is-btn-active': toggleStates.getWay4}" @click="toggleState('getWay4')">
              PC版
            </li>
            <li class="tab-list-item-group-4" :class="{'is-btn-active': !toggleStates.getWay4}" @click="toggleState('getWay4')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-4" :class="{'is-contents-active': toggleStates.getWay4}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_01.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                1.「USDT ERC20」を選択<br>
                ※「USDT ERC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                2. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                3. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                4. 「入金」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_06.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-4" :class="{'is-contents-active': !toggleStates.getWay4}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「入金」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_01.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                1.「USDT ERC20」を選択<br>
                ※「USDT ERC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                2. 金額を選択または入力
              </p>
              <p class="text_center h2-type">
                3. 参加する入金キャンペーンにチェックを入れる
              </p>
              <p class="text_center h2-type">
                4. 「入金」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_05.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_5" class="main-title">
          銀行キャッシュカードで出金する方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-5 " :class="{'is-btn-active': toggleStates.getWay5}" @click="toggleState('getWay5')">
              PC版
            </li>
            <li class="tab-list-item-group-5 " :class="{'is-btn-active': !toggleStates.getWay5}" @click="toggleState('getWay5')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-5" :class="{'is-contents-active': toggleStates.getWay5}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「出金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                1.「銀行カード」を選択
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_08.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>

              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する銀行キャッシュカードを選択
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_09.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>

              <p class="text_center h2-type">
                「送信する」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_10.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-5" :class="{'is-contents-active': !toggleStates.getWay5}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_06.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <h3 class="subheading fs_6">
                「出金」をタップ
              </h3>

              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                1. 銀行」を選択
              </p>

              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_10.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>
              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する銀行キャッシュカードを選択
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_02.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 5
              </h3>
              <p class="text_center h2-type">
                「送信する」をタップ
              </p>

              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_09.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>

        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_7" class="main-title">
          USDT TRC20の出金方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-7 " :class="{'is-btn-active': toggleStates.getWay7}" @click="toggleState('getWay7')">
              PC版
            </li>
            <li class="tab-list-item-group-7 " :class="{'is-btn-active': !toggleStates.getWay7}" @click="toggleState('getWay7')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-7" :class="{'is-contents-active': toggleStates.getWay7}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「出金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                仮想通貨を選択
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_11.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>

              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する「USDT TRC20」のアカウントを選択<br>「USDT TRC20」のウォレットアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_09.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 4
              </h1>

              <p class="text_center h2-type">
                「送信する」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_10.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-7" :class="{'is-contents-active': !toggleStates.getWay7}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_06.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                「出金」をタップ
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                仮想通貨を選択
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_11.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>
              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する「USDT TRC20」を選択<br>
                ※「USDT TRC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_04.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 5
              </h3>
              <p class="text_center h2-type">
                「送信する」をタップ
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_09.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_8" class="main-title">
          USDT ERC20の出金方法
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-8 " :class="{'is-btn-active': toggleStates.getWay8}" @click="toggleState('getWay8')">
              PC版
            </li>
            <li class="tab-list-item-group-8 " :class="{'is-btn-active': !toggleStates.getWay8}" @click="toggleState('getWay8')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-8" :class="{'is-contents-active': toggleStates.getWay8}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「出金」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>

              <p class="text_center h2-type">
                仮想通貨を選択
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_12.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>

              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する「USDT ERC20」のアカウントを選択<br>「USDT ERC20」のウォレットアドレスを紐づけする
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_09.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>

              <p class="text_center h2-type">
                間違いが無ければ、チェックを入れて「送信する」をクリック
              </p>

              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_pc_10.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-8" :class="{'is-contents-active': !toggleStates.getWay8}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_06.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                「出金」をタップ
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_07.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                仮想通貨を選択
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_11.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>
              <p class="text_center h2-type">
                1. 出金するウォレットを選択
              </p>
              <p class="text_center h2-type">
                2. 使用する「USDT ERC20」を選択<br>
                ※「USDT ERC20」ウォレットのアドレスを紐づけしてください
              </p>
              <p class="text_center h2-type">
                3. 金額を入力
              </p>
              <p class="text_center h2-type">
                4. 出金パスワードを入力
              </p>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_05.png`)" alt="">
              </div>

              <h3 class="main-title">
                ステップ 5
              </h3>
              <p class="text_center h2-type">
                「送信する」をタップ
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/payment_mb_09.png`)" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      toggleStates: {
        getWay1: true,
        getWay2: true,
        getWay3: true,
        getWay4: true,
        getWay5: true,
        getWay6: true,
        getWay7: true,
        getWay8: true
      }
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'payment-method',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleState(key) {
      if (this.toggleStates.hasOwnProperty(key)) {
        this.toggleStates[key] = !this.toggleStates[key]
      }
    },
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
